<template>
  <v-card class="px-2 pb-2 mb-3">
    <v-card-title primary-title>
      <span class="title">OrderBooks</span>
    </v-card-title>
    <v-container fluid>
      <v-layout pt-3>
        <v-flex xs6 md3 v-for="item in items" :key="item.id">
          <strong>
            <span>{{item.btnName}}</span>
          </strong>
          <div class="caption">
            <a target="blank" :href="url(item.id, item.tab_id)">Go to sheet</a>
          </div>
          <div class="button-container">
            <v-btn color="green" :loading="item.loading" :disabled="item.loading" class="ml-0" @click=submit(item)>
              Refresh
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import MongoService from '../../services/mongo.service'

export default {
    data() {
      return {
        items: [
            {
              'loading': false,
              'btnName': 'Opendax UAT',
              'params': {
                'client': 'OPENDAXUAT'
              },
              'id': '11f_8xYfZ4wpjHjt7IiVOGj-02Js8NyrqZAzoxgSjEMk',
              'tab_id': '1474851907'
            }
          ]
        }
    },
    methods: {
      url (id, tab) {
        return `https://docs.google.com/spreadsheets/d/${id}/view#gid=${tab}`
      },
      async submit (item) {
        item.loading = true
        const result = await MongoService.spreadsheetOperation.refreshOrderBook(item.params)
        item.loading = false
      }
    }
  }
</script>
